import React, { useEffect, useMemo, useState } from "react";
import * as S from "./SurveySearcher.style";
import { useTranslation } from "react-i18next";
import ZaiaInput from "../../../../../../zaiaComponents/zaiaInput";
import * as P from "../../../../../../../utils/pipes";
import { v4 as uuidv4 } from 'uuid';

function SurveySearcher({
  selectedProcess,
  changeFormField,
  processId,
  goNextInput,
  processList,
  inputSearchText
}) {

  const {t, i18n: { language }} = useTranslation("global");

  useEffect(() => {
    // get patient with id patientId from patientList
    const process = processList?.find((process) => process.value === processId);
    if(!selectedProcess.value && process) {
      changeFormField(
        [
          {
            value: process.value,
            text: process.text,
            fieldName: "program"
          }
        ]
      )
    }
  }, [processId, processList]);

  const getFilterText = (text) => {
    return inputSearchText 
      ? String(P.removeAccent(text)).toLowerCase().includes(P.removeAccent(inputSearchText).toLowerCase())
      : true
  }

  console.log("Process List", processList);

  const handleSelectProcess = (process) => {
    if(process.value !== selectedProcess.value && process.text !== selectedProcess.text) {
      changeFormField(
        [
          {
            value: process.value,
            text: process.text,
            fieldName: "program"
          },
          {
            value: null,
            text: "",
            fieldName: "survey"
          },
          {
            value: [],
            text: "",
            fieldName: "patientsList"
          },
        ]
      )
      goNextInput()
    }
  }
  

  const getProcessList = () => {

    return (
      <>
        <div className={`list__results ${inputSearchText === "" && "list__results--hidden"}`}>{t("globally.resultsFor")} "{inputSearchText}"</div>
        <div className="list__container">
          {
            processList?.map((process) => {
              if(getFilterText(process.text)) {
                return (
                  <S.ItemSurveys
                    key={uuidv4()}
                    selected={process.value === selectedProcess.value && process.text === selectedProcess.text}
                    disabled={process.surveysQuantity === 0}
                  >
                    <div className="item"
                      onClick={() => 
                        process.surveysQuantity !== 0 && handleSelectProcess(process)
                      }
                    >
                      <div className="item__left">
                        <div className="item__radio-button">
                          <div className="item__radio-button-content"></div>
                        </div>
                        <div className="item__text">
                          <div className="item__title">
                            {process.text}
                          </div>
                          <div className="item__subtitle">
                            {process.surveysQuantity} {t("globally.surveys")}
                          </div>
                        </div>
                      </div>
                      <div className="item__right">
                        <div className="item__patients">
                          {process.patientNumber} {t("globally.patients")}
                        </div>
                      </div>
                    </div>
                  </S.ItemSurveys>
                )
              } else {
                return null
              }
            })
          }
        </div>
      </>
    )

  }

  return (
    <S.SurveySearcher
      searcher={inputSearchText}
    >
      <div className="list">
        {
          getProcessList()
        }
      </div>
      
    </S.SurveySearcher>
  );
}

export default SurveySearcher;
